/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Watchdog configuration parameters
 * @export
 * @interface WatchdogDefinitionPort
 */
export interface WatchdogDefinitionPort {
    /**
     * ID of the port
     * @type {number}
     * @memberof WatchdogDefinitionPort
     */
    id?: number;
    /**
     * Locode of the port, 5 digit alphanumeric code
     * @type {string}
     * @memberof WatchdogDefinitionPort
     */
    locode?: string;
    /**
     * 
     * @type {string}
     * @memberof WatchdogDefinitionPort
     */
    name?: string;
}

/**
 * Check if a given object implements the WatchdogDefinitionPort interface.
 */
export function instanceOfWatchdogDefinitionPort(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WatchdogDefinitionPortFromJSON(json: any): WatchdogDefinitionPort {
    return WatchdogDefinitionPortFromJSONTyped(json, false);
}

export function WatchdogDefinitionPortFromJSONTyped(json: any, ignoreDiscriminator: boolean): WatchdogDefinitionPort {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'locode': !exists(json, 'locode') ? undefined : json['locode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function WatchdogDefinitionPortToJSON(value?: WatchdogDefinitionPort | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'locode': value.locode,
        'name': value.name,
    };
}

